import clsx from 'clsx'
import { ButtonHTMLAttributes } from 'react'

import { DesignIcon, IconSystemColor } from '@/shared/lib/icons'

import { Icon } from '../../icon/ui/icon'

import cl from './IconButton.module.scss'

interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
	icon: DesignIcon
	size?: string | number
	systemColor?: IconSystemColor
}

export const IconButton = (props: IconButtonProps) => {
	const { icon, size = 24, systemColor, className, ...otherProps } = props

	return (
		<button className={clsx(cl.root, className)} {...otherProps}>
			<Icon name={icon} size={size} systemColor={systemColor} />
		</button>
	)
}
